// src/redux/store.js

import { configureStore } from '@reduxjs/toolkit';
import columnsReducer from './columnsSlice';
import groupReducer from './groupSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Usa localStorage para web

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['columns'], // Solo persistir el slice 'columns'
};

const persistedColumnsReducer = persistReducer(persistConfig, columnsReducer);

const store = configureStore({
  reducer: {
    columns: persistedColumnsReducer,
    groups: groupReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar las acciones de redux-persist
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
